import React from 'react';

export default function MessageSolidIcon() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M17 2.42969H7C4 2.42969 2 4.42969 2 7.42969V13.4297C2 16.4297 4 18.4297 7 18.4297H11L15.45 21.3897C16.11 21.8297 17 21.3597 17 20.5597V18.4297C20 18.4297 22 16.4297 22 13.4297V7.42969C22 4.42969 20 2.42969 17 2.42969ZM15.5 11.2497H8.5C8.09 11.2497 7.75 10.9097 7.75 10.4997C7.75 10.0897 8.09 9.74969 8.5 9.74969H15.5C15.91 9.74969 16.25 10.0897 16.25 10.4997C16.25 10.9097 15.91 11.2497 15.5 11.2497Z"
        fill="currentColor"
      />
    </svg>
  );
}
